import { render, staticRenderFns } from "./PatientGeneralInfosCard.vue?vue&type=template&id=8af264f4&scoped=true"
import script from "./PatientGeneralInfosCard.vue?vue&type=script&lang=js"
export * from "./PatientGeneralInfosCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af264f4",
  null
  
)

export default component.exports